import { message } from "antd";
import axiosInstance from "../shared/axios";

// GET
const getConsentForm = async (params) => {
  try {
    let result = await axiosInstance.get("/consentForm/viewAll", {
      params,
    });

    if (result?.status === 200 && result?.data?.success) {
      return result?.data?.data;
    } else {
      message.error("Error while loading sessions");
      return null;
    }
  } catch (error) {
    message.error(
      error?.response?.data?.message || "Error while loading sessions",
    );
    return null;
  }
};

const addEditConsentForm = async (payload, id) => {
  try {
    const result = await axiosInstance.post(
      id ? "/consentForm/update" : "/consentForm/store",
      { ...payload, id: id || null },
    );

    // Accept any 2xx status
    if (result?.status >= 200 && result?.status < 300) {
      return { success: true, data: result.data };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to save consent form instructions",
    };
  }
};

const deleteConsentForm = async (id) => {
  try {
    const result = await axiosInstance.delete(`/consentForm/delete/${id}`);

    if (result?.status >= 200 && result?.status < 300) {
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        "Failed to delete consent form instruction",
    };
  }
};

export const consentForm = {
  getConsentForm,
  addEditConsentForm,
  deleteConsentForm,
};
